const types = {
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_TIPO_JUNTADA_SELECIONADA: 'SET_TIPO_JUNTADA_SELECIONADA',
  SET_DOCUMENTO_SELECIONADO: 'SET_DOCUMENTO_SELECIONADO',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types
